import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Collapse, Spin } from 'antd';

import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';

import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

import {
    estacioIntroduccioEnviarFormulari,
    estacioIntroduccioDescartarCanvis,
    obtenirDataHoraActualUTC,
    obtenirMunicipis
} from '../../actions';
import selectorIdEstacioSeleccionada from '../../selectors/selector_estacio_formulari_id';
import { selectorDataActual } from '../../selectors/selector_data_actual';
import {
    selectorMostrarErrors,
    selectorShaModificatSeccioLocalitzacio,
    selectorShaModificatSeccioVariables,
    selectorShaModificatSeccioMetadades,
    selectorShaModificatSeccioHistoricObservadors,
    selectorShaModificatSeccioIncidencies,
    selectorHiHaAlgunErrorASeccioLocalitzacio,
    selectorDadesBasiquesEditades,
    selectorHiHaErrorSeccioVariables,
    selectorEstaSeccioVariablesDeshabilitada,
    selectorPeticioInserirEnCurs
} from '../../selectors/selector_estacio_formulari_dades';
import {
    selectorNomsVariablesObligatories
} from '../../selectors/selector_estacio_formulari_estructura';
import EstacioIntroduccioDadesBasiques from '../../components/estacio/estacioIntroduccioDadesBasiques';
import EstacioIntroduccioHistoricObservadors from '../../components/estacio/estacioIntroduccioHistoricObservadors';
import EstacioIntroduccioFoto from './estacioIntroduccioFoto';
import EstacioIntroduccioIncidencies from './estacioIntroduccioIncidencies';
import EstacioIntroduccioLocalitzacio from './estacioIntroduccioLocalitzacio';
import EstacioIntroduccioVariables from './estacioIntroduccioVariables';
import EstacioIntroduccioMetadades from './estacioIntroduccioMetadades';

import { rutaEstacions, rutaDetallEstacions } from '../../routes/routeConstants';
import PopoverError from '../commons/popoverError';

const Panel = Collapse.Panel;
const colorModificacio = 'rgba(56, 173, 169, 0.5)';

class EstacioIntroduccio extends Component {

    constructor(props) {
        super(props);

        this.renderitzaBotonsCreacio = this.renderitzaBotonsCreacio.bind(this);
        this.renderitzaBotonsEdicio = this.renderitzaBotonsEdicio.bind(this);
    }

    componentDidMount() {
        this.props.obtenirDataHoraActualUTC();
        this.props.obtenirMunicipis();
    }

    renderitzaBotonsCreacio() {
        const { peticioEnviarFormulariEnCurs, estacioIntroduccioEnviarFormulari, router } = this.props;

        return <div className='estacio-introduccio-i-detall-botons'>
            <Button type='primary' size='large' disabled={peticioEnviarFormulariEnCurs} onClick={() => estacioIntroduccioEnviarFormulari(router)}>
                Guardar
            </Button>
            <Link to={rutaEstacions}>
                <Button size='large' disabled={peticioEnviarFormulariEnCurs}>
                    Cancel·lar
                </Button>
            </Link>
        </div>;
    }

    renderitzaBotonsEdicio() {
        const { peticioEnviarFormulariEnCurs, estacioIntroduccioEnviarFormulari, estacioIntroduccioDescartarCanvis, router } = this.props;

        return <div className='estacio-introduccio-i-detall-botons'>
            <Button type='primary' size='large' disabled={peticioEnviarFormulariEnCurs} onClick={() => estacioIntroduccioEnviarFormulari(router)}>
                Guardar
            </Button>
            <Link to={rutaDetallEstacions}>
                <Button size='large' disabled={peticioEnviarFormulariEnCurs} onClick={() => estacioIntroduccioDescartarCanvis()}>
                    Cancel·lar
                </Button>
            </Link>
        </div>;
    }

    generarIconaErrorHeaderSeccio(generarMissatgeError) {
        const contingutError = (generarMissatgeError) ? generarMissatgeError() : null;
        return <PopoverError contingut={contingutError} />;
    }

    renderHeaderSeccio(nom, iconaError) {
        return (
            <div>
                {nom}&nbsp;&nbsp;&nbsp;{iconaError}
            </div>
        );
    }

    generarPanelSeccio(keyPanelSeccio, seccio) {
        const { nom, shaModificat, component, hiHaErrors, deshabilitat, generarMissatgeError } = seccio;
        const estilPanel = shaModificat ? { background: colorModificacio } : {};
        const iconaError = (hiHaErrors) ? this.generarIconaErrorHeaderSeccio(generarMissatgeError) : null;

        return (
            <Panel header={this.renderHeaderSeccio(nom, iconaError)} key={keyPanelSeccio} style={estilPanel} disabled={deshabilitat}>
                {component}
            </Panel>
        );
    }

    render() {

        const {
            peticioEnviarFormulariEnCurs,
            idEstacioSeleccionada,
            dataActualText,
            mostrarErrors,
            shaModificatSeccioLocalitzacio,
            shaModificatSeccioVariables,
            shaModificatSeccioMetadades,
            shaModificatSeccioHistoricObservadors,
            shaModificatSeccioIncidencies,
            hiHaAlgunErrorASeccioLocalitzacio,
            dadesBasiques,
            estaSeccioVariablesDeshabilitada,
            hiHaErrorSeccioVariables,
            nomsVariablesObligatories
        } = this.props;

        const generarMissatgeErrorSeccioVariables = () => {

            const llistaVariablesObligatories = nomsVariablesObligatories.map(nomVariable => (
                <li key={nomVariable}>{nomVariable}</li>
            ));

            return (
                <div>
                    {'Almenys una de les següents variables ha d\'estar assignada a l\'estació:'}
                    <ul>{llistaVariablesObligatories}</ul>
                </div>
            );

        };

        const seccionsFormulari = [
            {
                nom: 'Localització',
                shaModificat: shaModificatSeccioLocalitzacio,
                component: <EstacioIntroduccioLocalitzacio />,
                hiHaErrors: mostrarErrors && hiHaAlgunErrorASeccioLocalitzacio
            },
            {
                nom: 'Variables',
                shaModificat: shaModificatSeccioVariables,
                component: <EstacioIntroduccioVariables />,
                deshabilitat: estaSeccioVariablesDeshabilitada,
                hiHaErrors: mostrarErrors && hiHaErrorSeccioVariables,
                generarMissatgeError: generarMissatgeErrorSeccioVariables
            },
            {
                nom: 'Metadades',
                shaModificat: shaModificatSeccioMetadades,
                component: <EstacioIntroduccioMetadades />
            },
            {
                nom: 'Històric d\'observadors',
                shaModificat: shaModificatSeccioHistoricObservadors,
                component: <EstacioIntroduccioHistoricObservadors
                    dataActualText={dataActualText}
                    dataBaixaEstacioText={dadesBasiques.dataBaixa}/>
            },
            {
                nom: 'Incidències',
                shaModificat: shaModificatSeccioIncidencies,
                component: <EstacioIntroduccioIncidencies
                    dataActualText={dataActualText} />
            }
        ];

        if (!dataActualText) {
            return null;
        }

        return (
            <Spin spinning={peticioEnviarFormulariEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER}>
                <div className='estacio-introduccio-i-detall'>
                    <div className='estacio-introduccio-i-detall-contenidor requadre-arrodonit-gris'>
                        <div className='estacio-introduccio-informacio'>
                            <EstacioIntroduccioDadesBasiques dataActualText={this.props.dataActualText} />
                            <EstacioIntroduccioFoto></EstacioIntroduccioFoto>
                            <div className='estacio-introduccio-collapse scrollable'>
                                <Collapse>
                                    {seccionsFormulari.map((seccio, index) => this.generarPanelSeccio(index, seccio))}
                                </Collapse>
                            </div>
                        </div>
                    </div>
                    {idEstacioSeleccionada === null ? this.renderitzaBotonsCreacio() : this.renderitzaBotonsEdicio()}
                </div>
            </Spin>
        );
    }
}

EstacioIntroduccio.propTypes = {
    peticioEnviarFormulariEnCurs: PropTypes.bool,
    idEstacioSeleccionada: PropTypes.number,
    estacioIntroduccioObtenirEstructura: PropTypes.func,
    estacioIntroduccioEnviarFormulari: PropTypes.func,
    estacioIntroduccioDescartarCanvis: PropTypes.func,
    dataActualText: PropTypes.string,
    mostrarErrors: PropTypes.bool,
    obtenirDataHoraActualUTC: PropTypes.func,
    obtenirMunicipis: PropTypes.func,
    shaModificatSeccioLocalitzacio: PropTypes.bool,
    shaModificatSeccioVariables: PropTypes.bool,
    shaModificatSeccioMetadades: PropTypes.bool,
    shaModificatSeccioHistoricObservadors: PropTypes.bool,
    shaModificatSeccioIncidencies: PropTypes.bool,
    hiHaAlgunErrorASeccioLocalitzacio: PropTypes.bool,
    dadesBasiques: PropTypes.object,
    router: PropTypes.object,
    estaSeccioVariablesDeshabilitada: PropTypes.bool,
    hiHaErrorSeccioVariables: PropTypes.bool,
    nomsVariablesObligatories: PropTypes.array
};

const mapStateToProps = (state) => {
    return {
        peticioEnviarFormulariEnCurs: selectorPeticioInserirEnCurs(state),
        idEstacioSeleccionada: selectorIdEstacioSeleccionada(state),
        dataActualText: selectorDataActual(state),
        dadesBasiques: selectorDadesBasiquesEditades(state),
        shaModificatSeccioLocalitzacio: selectorShaModificatSeccioLocalitzacio(state),
        shaModificatSeccioVariables: selectorShaModificatSeccioVariables(state),
        shaModificatSeccioMetadades: selectorShaModificatSeccioMetadades(state),
        shaModificatSeccioHistoricObservadors: selectorShaModificatSeccioHistoricObservadors(state),
        shaModificatSeccioIncidencies: selectorShaModificatSeccioIncidencies(state),
        hiHaAlgunErrorASeccioLocalitzacio: selectorHiHaAlgunErrorASeccioLocalitzacio(state),
        estaSeccioVariablesDeshabilitada: selectorEstaSeccioVariablesDeshabilitada(state),
        hiHaErrorSeccioVariables: selectorHiHaErrorSeccioVariables(state),
        mostrarErrors: selectorMostrarErrors(state),
        nomsVariablesObligatories: selectorNomsVariablesObligatories(state)
    };
};

const mapDispatchToProps = {
    estacioIntroduccioEnviarFormulari,
    estacioIntroduccioDescartarCanvis,
    obtenirDataHoraActualUTC,
    obtenirMunicipis
};

export default errorBoundaryWrapper(connect(mapStateToProps, mapDispatchToProps)(EstacioIntroduccio));


// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccio.js